// extracted by mini-css-extract-plugin
module.exports = {"close":"dialog-new_close__2e5Ih"};